/**
 * Výber hrany pre dielec z materiálu — hrany zákazky, odporúčané pre
 * materiál a celý cenník. Od KOLA 201 je to `VyberHranyDialog` (jedno
 * okno pre celú appku); meno ostáva, volá ho šesť miest.
 */
import { VyberHranyDialog } from "@/components/dielec/VyberHranyDialog";

export interface SlotEdgePickerDialogProps {
  open: boolean;
  slotMaterialId: string;
  slotId?: string;
  hrubaHranaMm?: string;
  /** ID varianty — zobrazí hore skupinu hrán už použitých v zákazke. */
  variantaId?: string;
  currentId: string | null;
  /**
   * Hrúbka dosky dielca — cenník sa predfiltruje na šírku pásky, ktorú
   * doska potrebuje (Nastavenia → Hrúbky dosiek). Bez nej všetky.
   */
  zMm?: number;
  /**
   * Hrany na stranách dielca (KOLO 196, pridaná hrana) — v skupine
   * „V zákazke" idú navrch so štítkom „na dielci".
   */
  naDielci?: readonly string[];
  /** Bez „Pridať aj k hranám materiálu" — pridaná hrana nemení pool slotu. */
  bezKuracie?: boolean;
  /** Nadpis okna; predvolený „Vybrať hranu". */
  nadpis?: string;
  onClose: () => void;
  onSelect: (id: string) => void;
}

export function SlotEdgePickerDialog({
  onSelect,
  ...props
}: SlotEdgePickerDialogProps): JSX.Element {
  return <VyberHranyDialog {...props} onSelect={(id) => onSelect(id)} />;
}
